import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Box,
    Button,
    Grid,
    IconButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form/bootstrap';

const ReactHookFormArrayEmails = ({
    btnCreate = true,
    btnDelete = true,
    control,
    disabled,
}) => {
    const { t } = useTranslation();
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'emails',
    });
    return (
        <>
            {fields.length > 0 && (
                <Grid size={18}>
                    {fields.map((item, i) => (
                        <Grid container key={item.id}>
                            <Grid size={18}>
                                <Typography variant="body2" fontWeight="bold">
                                    {t('Email')} {i + 1}
                                </Typography>
                            </Grid>
                            <Grid size={{ md: 9, xs: 18 }}>
                                <ReactHookFormInput
                                    control={control}
                                    disabled={disabled}
                                    label={t('Email')}
                                    name={`emails.${i}.email`}
                                />
                            </Grid>
                            <Grid size={{ md: 9, xs: 18 }}>
                                <Box
                                    sx={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        gap: '5px',
                                    }}
                                >
                                    <ReactHookFormSelect
                                        control={control}
                                        disabled={disabled}
                                        label={t('Type')}
                                        name={`emails.${i}.email_type`}
                                        options={[
                                            {
                                                disabled: true,
                                                label: t('Select'),
                                                value: '',
                                            },
                                            {
                                                label: t('Work'),
                                                value: '0',
                                            },
                                            {
                                                label: t('Personal'),
                                                value: '1',
                                            },
                                            {
                                                label: t('Other'),
                                                value: '2',
                                            },
                                        ]}
                                    />
                                    {btnDelete && (
                                        <IconButton
                                            onClick={() => remove(i)}
                                            sx={{ mb: 2 }}
                                        >
                                            <DeleteIcon fontSize="medium" />
                                        </IconButton>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            )}
            <Grid size={18}>
                <Button
                    disabled={disabled}
                    endIcon={<AddIcon />}
                    onClick={() => append({ email: '', email_type: 0 })}
                    sx={{ width: { md: 'auto', xs: '100%' } }}
                    type="button"
                    variant="outlined"
                    visible={btnCreate}
                >
                    {t('Add email')}
                </Button>
            </Grid>
        </>
    );
};

ReactHookFormArrayEmails.propTypes = {
    btnCreate: PropTypes.bool,
    btnDelete: PropTypes.bool,
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default ReactHookFormArrayEmails;
